import { ActionTree } from 'vuex';
import { RootState } from '@/store/store';
import { IAlertState } from '@/alert/store/alert.types';
import { IAlert } from '@lib-shared/alert/types/alert';
import { AlertType } from '@lib-shared/alert/types/enums/alert-types';
import { EAlertAction, EAlertMutation } from '@/alert/store/alert.constants';
import { AlertConstants } from '@lib-shared/alert/constants/alert.constants';

export const actions: ActionTree<IAlertState, RootState> = {
  async [EAlertAction.ShowInfo]({ dispatch }, text: string) {
    const alert: IAlert = {
      text,
      type: AlertType.Info,
      timeout: AlertConstants.successTimeout,
    };
    dispatch(EAlertAction.Add, alert);
  },
  async [EAlertAction.ShowSuccess]({ dispatch }, text: string) {
    const alert: IAlert = {
      text,
      type: AlertType.Success,
      timeout: AlertConstants.successTimeout,
    };
    dispatch(EAlertAction.Add, alert);
  },
  async [EAlertAction.ShowWarning]({ dispatch }, text: string) {
    const alert: IAlert = {
      text,
      type: AlertType.Warning,
      timeout: AlertConstants.errorTimeout,
    };
    dispatch(EAlertAction.Add, alert);
  },
  async [EAlertAction.ShowDanger]({ dispatch }, text: string) {
    const alert: IAlert = {
      text,
      type: AlertType.Danger,
      timeout: AlertConstants.errorTimeout,
    };
    dispatch(EAlertAction.Add, alert);
  },
  async [EAlertAction.Add]({ commit, state }, newAlert: IAlert) {
    if (state.queue.some(alert => alert.text === newAlert.text)) {
      return;
    }
    commit(EAlertMutation.Add, newAlert);
  },
  async [EAlertAction.Remove]({ commit }) {
    commit(EAlertMutation.Remove);
  },
};
